import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./firebase";
import { rtdbPlugin } from "vuefire";
import VueWow from "vue-wow";
import CKEditor from "@ckeditor/ckeditor5-vue";
import x5GMaps from "x5-gmaps";

require("./assets/css/style.css");

Vue.config.productionTip = false;

Vue.use(rtdbPlugin);
Vue.use(VueWow);
Vue.use(CKEditor);
Vue.use(x5GMaps, "AIzaSyDeFnilgWW-7VhU7U6pi1tgeT2nzu725G4");

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
